function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { getMetaValue } from "./helpers";
export var BlobRecord = /*#__PURE__*/function () {
  function BlobRecord(file, checksum, url) {
    var _this = this;

    _classCallCheck(this, BlobRecord);

    this.file = file;
    this.attributes = {
      filename: file.name,
      content_type: file.type,
      byte_size: file.size,
      checksum: checksum
    };
    this.xhr = new XMLHttpRequest();
    this.xhr.open("POST", url, true);
    this.xhr.responseType = "json";
    this.xhr.setRequestHeader("Content-Type", "application/json");
    this.xhr.setRequestHeader("Accept", "application/json");
    this.xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    var csrfToken = getMetaValue("csrf-token");

    if (csrfToken != undefined) {
      this.xhr.setRequestHeader("X-CSRF-Token", csrfToken);
    }

    this.xhr.addEventListener("load", function (event) {
      return _this.requestDidLoad(event);
    });
    this.xhr.addEventListener("error", function (event) {
      return _this.requestDidError(event);
    });
  }

  _createClass(BlobRecord, [{
    key: "create",
    value: function create(callback) {
      this.callback = callback;
      this.xhr.send(JSON.stringify({
        blob: this.attributes
      }));
    }
  }, {
    key: "requestDidLoad",
    value: function requestDidLoad(event) {
      if (this.status >= 200 && this.status < 300) {
        var response = this.response;
        var direct_upload = response.direct_upload;
        delete response.direct_upload;
        this.attributes = response;
        this.directUploadData = direct_upload;
        this.callback(null, this.toJSON());
      } else {
        this.requestDidError(event);
      }
    }
  }, {
    key: "requestDidError",
    value: function requestDidError(event) {
      this.callback("Error creating Blob for \"".concat(this.file.name, "\". Status: ").concat(this.status));
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var result = {};

      for (var key in this.attributes) {
        result[key] = this.attributes[key];
      }

      return result;
    }
  }, {
    key: "status",
    get: function get() {
      return this.xhr.status;
    }
  }, {
    key: "response",
    get: function get() {
      var _this$xhr = this.xhr,
          responseType = _this$xhr.responseType,
          response = _this$xhr.response;

      if (responseType == "json") {
        return response;
      } else {
        // Shim for IE 11: https://connect.microsoft.com/IE/feedback/details/794808
        return JSON.parse(response);
      }
    }
  }]);

  return BlobRecord;
}();